import { AddressFlow } from '@energy-retailer/constants';

import { getIsInsideServiceArea } from '@/lib/utils/get-is-inside-service-area';

import type { PropertySchema } from '@energy-retailer/schema';

export const getAddressFlow = ({
  data,
}: {
  data: PropertySchema[];
}): AddressFlow => {
  const multipleAddresses = data.length > 1;
  
  if (data.length === 0) {
    return AddressFlow.AddressNotFoundRequestNMI;
  }

  const firstAddress = data[0];
  const isGasAvailable = firstAddress.isGasAvailable;

  const isAreaInService = getIsInsideServiceArea(
    firstAddress.address.state,
    firstAddress.address.postcode
  );

  if (!isAreaInService) {
    return AddressFlow.OutOfService;
  }

  if (!firstAddress.customerType) {
    return AddressFlow.AddressNotFound;
  }

  if (multipleAddresses) {
    if (!isGasAvailable) {
      return AddressFlow.MultiNoGas;
    }

    return AddressFlow.Multi;
  }

  if (!isGasAvailable) {
    return AddressFlow.SingleNoGas;
  }

  return AddressFlow.Single;
};
